const userMenuDefaultState = {
  userMenuOpen: false,
  dashboardOpeningState: "account",
}

export default (state = userMenuDefaultState, action) => {
  switch (action.type) {
    case "OPEN_USER_MENU":
      return {
        ...state,
        userMenuOpen: true,
      }
    case "CLOSE_USER_MENU":
      return {
        ...state,
        userMenuOpen: false,
      }
    case "DASHBOARD_OPENING_STATE":
      return {
        ...state,
        dashboardOpeningState: action.dashboardOpeningState,
      }

    default:
      return state
  }
}
